import React from "react";
import { Context } from "../types";
import { Button } from "../components/Button";

interface ContextsSettingsSectionProps {
  contexts: Context[];
  onAddContext: () => void;
  onEditContext: (context: Context) => void;
}

export const ContextsSettingsSection: React.FC<ContextsSettingsSectionProps> = ({
  contexts,
  onAddContext,
  onEditContext,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ margin: 0 }}>Contexts</h3>
        <Button size="sm" onClick={onAddContext}>
          Add Context
        </Button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
        {contexts.map((context, index) => (
          <div
            key={context.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              margin: "0 -16px",
              backgroundColor: "#fff",
              borderTop: index === 0 ? "0.5px solid #ccc" : "none",
              borderBottom: "0.5px solid #ccc",
              opacity: context.archived ? 0.5 : 1,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  backgroundColor: context.color,
                  flexShrink: 0
                }}
              />
              <span style={{
                textDecoration: context.archived ? "line-through" : "none"
              }}>
                {context.name}
              </span>
            </div>
            <Button
              size="sm"
              variant="outline"
              onClick={() => onEditContext(context)}
            >
              Edit
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};